import { uniqBy } from 'lodash';
import type { AdditionalHts } from '@xbcb/api-gateway-client';
import { HtsObject } from 'types';

export const getAdditionalGrouped = (
  htsObj: HtsObject | undefined,
  originCountryCode: string,
) => {
  const additional = (htsObj?.additional ?? []).filter(
    (a: AdditionalHts) =>
      a.include?.some(
        (countryCode: string) => countryCode === originCountryCode,
      ) ||
      (a.exclude &&
        !a.exclude.some(
          (countryCode: string) => countryCode === originCountryCode,
        )),
  );

  // If multiple additional HTS with RECIPROCAL_POLICY type, prioritize country-specific tariff.
  // tt: https://t.corp.amazon.com/D328273297/communication
  const reciprocalPolicies = additional.filter(
    (a) => a.type === 'RECIPROCAL_POLICY',
  );
  const countrySpecificReciprocal = reciprocalPolicies.filter(
    (a) => originCountryCode && a.include?.includes(originCountryCode),
  );
  const otherTypes = additional.filter((a) => a.type !== 'RECIPROCAL_POLICY');

  const finalAdditional = [
    ...(countrySpecificReciprocal.length > 0
      ? countrySpecificReciprocal
      : reciprocalPolicies),
    ...otherTypes,
  ];
  return uniqBy(finalAdditional, 'type');
};
